__turbopack_context__.v({
  "pointlistpoint": "mpS_WG_pointlistpoint",
  "pointlistpoint__heading": "mpS_WG_pointlistpoint__heading",
  "pointlistpoint__number": "mpS_WG_pointlistpoint__number",
  "pointlistpoint__paragraph": "mpS_WG_pointlistpoint__paragraph",
  "top": "mpS_WG_top",
});
